// import { Currency } from './utils'
import { YscClstags } from '@/utils/clstags'
export const appConfig = {
  appId: 8
}
// 常用操作
export const HomeCommonOperation = [
  {
    name: '存货总体分析',
    link: '/il/overall-analysis',
    icon: 'md-cube',
    bgColor: '#4990e2',
    clstag: YscClstags.home.comOperation_il
  },
  {
    name: '库存总体分析',
    link: '/ihs/ihs-board',
    icon: 'ios-archive',
    bgColor: '#5ebfa8',
    clstag: YscClstags.home.comOperation_ihs
  },
  {
    name: '销量总体分析',
    link: '/sfs/history',
    icon: 'logo-buffer',
    bgColor: '#5463ca',
    clstag: YscClstags.home.comOperation_sfs
  },
  {
    name: '预测补货',
    link: '/pbs/wbprediction',
    icon: 'ios-podium',
    bgColor: '#a97f5a',
    clstag: YscClstags.home.comOperation_pbsPre
  },
  {
    name: '分仓补货',
    link: '/pbs/whseparate',
    icon: 'md-filing',
    bgColor: '#a4cc44',
    clstag: YscClstags.home.comOperation_pbsSep
  },
  {
    name: '滞销处理建议',
    link: '/vrs/vrs-workbench',
    icon: 'md-alert',
    bgColor: '#63c2db',
    clstag: YscClstags.home.comOperation_vrs
  },
]

// 公告
export const HomeNotices = [
  {
    'id': 1,
    'title': '智慧供应链库存产品诸葛.智享全面升级袭来！',
    'time': '30天之前',
    'link': '/notice/notice1.html',
    'route': '/notice/notice1',
  },
  {
    'id': 2,
    'title': '产品使用文档，欢迎下载！',
    'time': '30天之前',
    'link': '/documents',
    'route': '/documents',
  },
  {
    'id': 3,
    'title': '产品售后服务，问题解答渠道通知！',
    'time': '30天之前',
    'link': '/notice/notice4.html',
    'route': '/notice/notice4',
  },
  {
    'id': 4,
    'title': '产品常见问题介绍！',
    'time': '30天之前',
    'link': '/questions',
    'route': '/questions',
  },
  {
    'id': 5,
    'title': '对我们产品还满意吗？欢迎您的反馈！',
    'time': '30天之前',
    'link': '/notice/notice6.html',
    'route': '/notice/notice6',
  }
]
// 核心指标-库存指标
export const HomeIhsKPILegend = [
  {
    name: '缺货比',
    key: 'spot_rate',
    unit: '%',
    value: '0'
  },
  {
    name: '跨区占比',
    key: 'across_store_rate',
    unit: '%',  
    value: '0'
  },
  {
    name: '滞销占比',
    key: 'zx_rate',
    unit: '%',
    value: '0'
  },
  {
    name: '件数周转天数',
    key: 'turnover',
    unit: '天',
    value: '0'
  },
  {
    name: 'MTD周转天数',
    key: 'turnover_w',
    unit: '天',  
    value: '0'
  },
]
// 提醒设置-消息提醒设置 reminderFreq
export const SellerRemindHz = [
  { value: 1, label: '每天' },
  { value: 2, label: '每周' },
  { value: 3, label: '每月' },
]
export const SellerRemindWeekHz = [
  { value: '1', label: '周一'  },
  { value: '2', label: '周二' },
  { value: '3', label: '周三' },
  { value: '4', label: '周四' },
  { value: '5', label: '周五' },
  { value: '6', label: '周六' },
  { value: '7', label: '周日' },
]
export const SellerRemindMonthHz = [
  { value: '01', label: '月初' },
  { value: '02', label: '月中' },
  { value: '03', label: '月末' },
]
// 提醒设置-全部消息
export const MessageList = {
  "-1": "尊敬的用户您好，系统根据您关注的库存数据给您推送了该消息，请您及时查阅！",
  "2": "尊敬的用户您好，系统根据您关注的库存指标，为您推送了该条消息，请您及时查阅！",
  "4": "尊敬的用户您好，系统根据您关注的补货数据，为您推送了该条消息，请您及时查阅！",
  "5" : "尊敬的用户您好，系统根据您关注的滞销商品数据，为您推送了该条消息，请您及时查阅！"
}